import { render, staticRenderFns } from "./Disputes.vue?vue&type=template&id=6aa89c4e&scoped=true"
import script from "./Disputes.vue?vue&type=script&lang=js"
export * from "./Disputes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa89c4e",
  null
  
)

export default component.exports